import { AxiosResponse } from 'axios'
import { useState } from 'react'
import { fullFlchUrl } from '@/src/BlinkAdminApiClient'
import Button from '@/src/components/core/Button'
import ErrorMessage from '@/src/components/core/ErrorMessage'
import Honeypot from '@/src/components/core/Honeypot'
import { Input } from '@/src/components/core/Input'
import { TextArea } from '@/src/components/core/Textarea'
import useLaravelForm from '@/src/hooks/useLaravelForm'

type ContactFormValues = {
  email: string
  message: string
  website: string
}

export default function ContactForm({ context }: { context: string }) {
  const [success, setSuccess] = useState(false)
  const [sending, setSending] = useState(false)

  const { handleSubmit, register, errorMessage, reset } =
    useLaravelForm<ContactFormValues>({
      defaultValues: { email: '', message: '', website: '' },
    })

  if (success) {
    return (
      <div className="rounded-md border border-gray-150 bg-white px-5 py-6">
        <p className="font-black">Danke für deine Anfrage!</p>
        <p className="mt-2 text-gray-800">
          Wir melden uns so schnell wie möglich bei dir.
        </p>
        <Button
          version="gray-outlined"
          onClick={() => setSuccess(false)}
          className="mt-6"
        >
          Weitere Anfrage senden
        </Button>
      </div>
    )
  }

  return (
    <form
      onSubmit={handleSubmit(
        (_response: AxiosResponse) => {
          setSuccess(true)
          reset()
          setSending(false)
        },
        (data) => {
          setSending(true)
          return { ...data, context }
        },
        () => {
          setSending(false)
        }
      )}
      method="POST"
      action={fullFlchUrl('contact')}
    >
      <div className="space-y-4">
        <Input
          label="E-Mail"
          kind="email"
          color="white-blue"
          labelType="block"
          required
          {...register('email')}
        />
        <TextArea
          label="Deine Nachricht (z.B. Wunschtermine)"
          color="white-blue"
          labelType="block"
          rows={4}
          required
          {...register('message')}
        />
        <Honeypot {...register('website')} />
      </div>
      {errorMessage && (
        <div className="mt-4">
          <ErrorMessage>{errorMessage}</ErrorMessage>
        </div>
      )}
      <Button
        type="submit"
        version="blue"
        loading={sending}
        className="mt-6 w-full md:w-auto"
      >
        Anfrage senden
      </Button>
    </form>
  )
}
